import { render, staticRenderFns } from "./UploadAptoMedico.vue?vue&type=template&id=5e277d88&scoped=true&"
import script from "./UploadAptoMedico.vue?vue&type=script&lang=js&"
export * from "./UploadAptoMedico.vue?vue&type=script&lang=js&"
import style0 from "./UploadAptoMedico.vue?vue&type=style&index=0&id=5e277d88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e277d88",
  null
  
)

export default component.exports